import { combineReducers } from 'redux';

import { reducer as createToken } from './createTokenModule';
import { reducer as bindAgreement } from './bindAgreementModule';

export default combineReducers({
	createToken,
	bindAgreement,
});
